/**
 * @class
 */
import Base from './attribute_multiselect';

import {ids as attributeTypeIds} from '@netx/core-asset/properties/attributes';

export default class Attribute_Tag extends Base {
	/** @type {object} */
	get defaults() {
		return {
			...super.defaults,
			type: attributeTypeIds.tag,
		};
	}

	/**
	 * isFlexible() returns true if this attribute is defined as having 'folksonomy'
	 * and will therefore allow users to add terms via the select2 tagging system.
	 * @override
	 * @return {boolean} Is flexible
	 */
	isFlexible() {
		return this.get('spec2') === 1;
	}

	/** @type {string} */
	static get __name__() {
		return 'Attribute_Tag';
	}
}
